export default __webpack_public_path__ + "static/media/CRESTON.a2a50cd8.jpg";